import Vue from 'vue';
import VueRouter from 'vue-router';

import generateCert from "@/views/generateCert.vue";
import newGenerateCert from "@/views/newGenerateCert.vue";

Vue.use(VueRouter);

const routes = [
    { path: '/', name: 'home', component: newGenerateCert },
    { path: '/old', name: 'old', component: generateCert }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;